<script lang="ts" setup>
	import {useFilters} from '@/store/filter.store';
	import {useAppStore} from '@/store/app.store';

	const appStore = useAppStore();
	const filterStore = useFilters();

	const toggleFilters = (): void => {
		filterStore.collapseActiveFilter();
		appStore.toggleFilterBlock();
	};
</script>

<template>
	<div class="catalog-overview-header__filter-toggle">
		<button data-filter-toggle @click="toggleFilters">
			{{ $t('site.products.overview.filters.title') }}
		</button>
	</div>
</template>
